import { TSoundModel, ESound } from "@karma-games/angular-devkit/src/lib/modules/sound";

export const soundExtension = "mp3";

export const soundModels: TSoundModel[] = [
    {
        id: ESound.Click,
        pathToFile: `assets/sounds/utility/ButtonPressed.${soundExtension}`,
        defaultVolume: 0.2
    },
    {
        id: ESound.ToggleOn,
        pathToFile: `assets/sounds/utility/ToggleOn.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: ESound.ToggleOff,
        pathToFile: `assets/sounds/utility/ToggleOn.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: ESound.ToastError,
        pathToFile: `assets/sounds/utility/Toast_Error.${soundExtension}`,
        defaultVolume: 0.2
    },
    {
        id: ESound.ToastInfo,
        pathToFile: `assets/sounds/utility/Toast_Hint.${soundExtension}`,
        defaultVolume: 0.2
    },
    {
        id: ESound.ToastSuccess,
        pathToFile: `assets/sounds/utility/Toast_Confirmation.${soundExtension}`,
        defaultVolume: 0.2
    },
    {
        id: ESound.ToastWarn,
        pathToFile: `assets/sounds/utility/Toast_Hint.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: ESound.DefaultBackgroundMusic,
        pathToFile: `assets/sounds/background/ambient_loop.${soundExtension}`,
        defaultVolume: 0.2
    },
    {
        id: ESound.PopupSlide,
        pathToFile: `assets/sounds/utility/PopupOpen.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: ESound.PopupClose,
        pathToFile: `assets/sounds/utility/PopupClose.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: ESound.DropdownOpen,
        pathToFile: `assets/sounds/utility/DropdownOpen.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: ESound.DropdownClose,
        pathToFile: `assets/sounds/utility/DropdownClose.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "GameAnimationMainSound",
        pathToFile: `assets/sounds/game-animation-sounds/Music_loop.${soundExtension}`,
        defaultVolume: 0.15
    },
    {
        id: "GameAnimationIdleSound",
        pathToFile: `assets/sounds/game-animation-sounds/idle state.${soundExtension}`,
        defaultVolume: 0.15
    },
    {
        id: "GameAnimationFallSound",
        pathToFile: `assets/sounds/game-animation-sounds/Fall down.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "GameAnimationStepsSound",
        pathToFile: `assets/sounds/game-animation-sounds/Steps.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "GameAnimationMultiplierSound",
        pathToFile: `assets/sounds/game-animation-sounds/Multiplier1.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "GameAnimationMultiplierSound-1",
        pathToFile: `assets/sounds/game-animation-sounds/Multiplier2.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "GameAnimationMultiplierSound-2",
        pathToFile: `assets/sounds/game-animation-sounds/Multiplier3.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "GameAnimationMultiplierSound-3",
        pathToFile: `assets/sounds/game-animation-sounds/Multiplier4.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "GameAnimationBigMultiplierSound",
        pathToFile: `assets/sounds/game-animation-sounds/BigMultiplier.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: ESound.CoinCounter,
        pathToFile: `assets/sounds/utility/CoinCounter.${soundExtension}`,
        defaultVolume: 0.4
    },
    {
        id: "WalletAnimation",
        pathToFile: `assets/sounds/walletAnimSound.${soundExtension}`,
        defaultVolume: 0.3
    },
    {
        id: "BetPressed",
        pathToFile: `assets/sounds/utility/BetPressed.${soundExtension}`,
        defaultVolume: 0.2
    },
    {
        id: "CashOutPressed",
        pathToFile: `assets/sounds/utility/CashOutPressed.${soundExtension}`,
        defaultVolume: 0.2
    },
    {
        id: ESound.SegmentSound,
        pathToFile: `assets/sounds/utility/SegmentSound.${soundExtension}`,
        defaultVolume: 0.2
    },
];
